<template>
  <div id="profile">
    <md-avatar class="md-large md-profile md-elevation-10">
      <img :src="image" />
    </md-avatar>
  </div>
</template>

<script>

export default {
  name: 'Profile',
  props: {
    image: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#profile {
  text-align: center;
}

.left-profile {
  background-color: #565656;
  border-right: 1px solid #383838;
}

.md-profile {
    margin-top:-100px;
    width: 200px;
    height: 200px;
    border-radius: 200px;
    z-index: 999;
}
</style>
